const PROFILE_STATUS = {
  DISABLED: 'disabled',
  PENDING: 'pending',
};

export default PROFILE_STATUS;
